import {
  createParser,
  parseAsArrayOf,
  parseAsFloat,
  parseAsStringLiteral,
  parseAsTimestamp,
} from "nuqs";
import {
  COMMITMENTS,
  JOB_CATEGORIES,
  PRIORITIES,
  RATES,
  RESUME_REQUIRED,
  WORK_MODELS,
} from "@/config/constants";
import {
  ARRAY_DELIMITER,
  RANGE_DELIMITER,
  SLIDER_DELIMITER,
} from "@/lib/delimiters";

// Custom parsers with fixed precision serialization for client-side use
const parseAsLatitude = createParser({
  parse: (value) => Number.parseFloat(value),
  serialize: (value) => value?.toFixed(6),
});

const parseAsLongitude = createParser({
  parse: (value) => Number.parseFloat(value),
  serialize: (value) => value?.toFixed(6),
});

const parseAsZoom = createParser({
  parse: (value) => Number.parseFloat(value),
  serialize: (value) => value?.toFixed(6),
});

// Client-side search params parser for use in useQueryStates
export const marketplaceSearchParamsParser = {
  latitude: parseAsLatitude,
  longitude: parseAsLongitude,
  zoom: parseAsZoom,
  compensation: parseAsArrayOf(parseAsFloat, SLIDER_DELIMITER),
  compensation_rate: parseAsArrayOf(
    parseAsStringLiteral(RATES.map((r) => r.value)),
    ARRAY_DELIMITER
  ),
  category: parseAsArrayOf(
    parseAsStringLiteral(JOB_CATEGORIES.map((c) => c.value)),
    ARRAY_DELIMITER
  ),
  work_model: parseAsArrayOf(
    parseAsStringLiteral(WORK_MODELS.map((w) => w.value)),
    ARRAY_DELIMITER
  ),
  commitment: parseAsArrayOf(
    parseAsStringLiteral(COMMITMENTS.map((c) => c.value)),
    ARRAY_DELIMITER
  ),
  priority: parseAsArrayOf(
    parseAsStringLiteral(PRIORITIES.map((p) => p.value)),
    ARRAY_DELIMITER
  ),
  resume: parseAsArrayOf(
    parseAsStringLiteral(RESUME_REQUIRED.map((r) => r.value)),
    ARRAY_DELIMITER
  ),
  posted_date: parseAsArrayOf(parseAsTimestamp, RANGE_DELIMITER),
} as const;
